import {DataGroup} from 'vis-timeline/esnext';

const LOCATIONS: DataGroup[] = [
    {
        id: 'r1',
        content: '010',
        title: 'Diesen Standort und alle betroffenen Maschinen aus-/einblenden',
        nestedGroups: [
            'm11',
            'm12'
        ],
        showNested: true
    },
    {
        id: 'r2',
        content: '020',
        title: 'Diesen Standort und alle betroffenen Maschinen aus-/einblenden',
        nestedGroups: [
            'm21'
        ],
        showNested: true
    }
];

export {LOCATIONS};
